import React, { Component } from 'react';
import TableParent from '../commonComponents/TableParent';
import CallAPI from '../commonComponents/AxiosHelper';
import LoadingComponent from '../commonComponents/LoadingComponent';
import Form from '../commonComponents/Form';
import Formv2 from '../commonComponents/Form.v2';
import ErrorComponent from '../commonComponents/ErrorComponent';
import * as csv from 'csvtojson';
import { connect } from 'react-redux';
import { setToolId, setTableData } from '../../action/index';
import { bindActionCreators } from 'redux';
import { DBService } from '../../../src/components/SummaryComponents/component/IndexedDB';

var syncDataFormData = {
    "status": {
        "name": "status", "label": "Sync Status", "type": "dropdown", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "On", "value": 1 },
            { "name": "Off", "value": 0 }
        ], "requiredFlag": true
    },
    "frequency": {
        "name": "frequency", "label": "Frequency", "type": "dropdown", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "Daily", "value": 'daily' },
            { "name": "Weekly", "value": "weekly" },
            { "name": "Monthly", "value": "monthly" }
        ], "requiredFlag": true
    },
    "timeOfDay": {
        "name": "timeOfDay", "label": "Time of the day", "type": "time", "step": "1", "requiredFlag": true
    },
    "dayOfWeek": {
        "name": "dayOfWeek", "label": "Day of Week", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "Sunday", "value": "sun" },
            { "name": "Monday", "value": "mon" },
            { "name": "Tuesday", "value": "tue" },
            { "name": "Wednesday", "value": "wed" },
            { "name": "Thursday", "value": "thurs" },
            { "name": "Friday", "value": "fri" },
            { "name": "Saturday", "value": "sat" }
        ], "requiredFlag": false
    },
    "dayOfMonth": {
        "name": "dayOfMonth", "label": "Day of Month", "min": "1", "max": "31", "requiredFlag": false
    },
}

var refreshFilterFormData = {
    "refreshFilter": {
        "name": "refreshFilter", "label": "Select Refresh Type", "type": "dropdown", "options": [
            { "name": "Select Option", "value": "" },
            { "name": "Refresh Filter (Light Mode)", "value": "elasticsearch" },
            { "name": "Refresh Filter", "value": "none"},
            { "name": "Clean Data and Refresh Filter", "value": "true"}
        ], "requiredFlag": true,
        
    }
}
class DatasetComponent extends Component {

    constructor(props) {
        super(props);
        this._db = new DBService();
        this.state = {
            metric: null,
            tools: null,
            tables: null,
            isProcessing: false,
            clearFlag: null,
            upload: { "title": "Create Dataset", "button_name": "Make Dataset", "type": 0 },
            syncDataFormStates: JSON.parse(JSON.stringify(syncDataFormData)),
            refreshFilterState: JSON.parse(JSON.stringify(refreshFilterFormData)),
            dimensionOptions: []
        };

        this.bulkFormData = {
            "isDerived": {
                "name": "isDerived", "label": "Metric Type", "type": "dropdown", "options": [
                    // Don't change option needed
                    { "name": "Select Option", "value": "3" },
                    { "name": "Default", "value": "0", },
                    { "name": "Derived", "value": "2" },
                    { "name": "Underlying", "value": "1" },
                ]
            },
            "defaultFormula": {
                "name": "defaultFormula", "label": "Aggregation Type", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" },
                    { "name": "Sum", "value": "sum", },
                    { "name": "Average", "value": "avg" },
                    { "name": "None", "value": null },
                ]
            },
            "isDisplay": {
                "name": "isDisplay", "label": "Metric Display", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "3" },
                    { "name": "Show", "value": "1" },
                    { "name": "Hide", "value": "0" },
                    { "name": "Delete", "value": "2" },
                ]
            },
        }

        this.importFormData = {
            "newDatasetName": {
                "name": "newDatasetName", "id": "newDatasetName", "label": "Dataset Name", "type": "text", requiredFlag: true,
            },
            "fileImport": {
                "name": "fileImport", "type": "newFile", "id": "fileImport", "accept": ".zip", "span1": "Supported file format is .zip", "span2": "", requiredFlag: true
            }            
        }

        this.headerMapping = {
            "name": "Name",
            "isDerived": "Metric Type",
            "formula": "Formulae",
            "defaultFormula": "Aggregation Type",
            "isDisplay": "Display"
        }
        this.buttons = {
            // "addButton": [{ "id": "addButton", "label": "Create Dataset", "type": "normal", "display": true, "action": "add", 'modal_id': "#addContent" }],
            "dropdownConfig": [{
                "id": "id", "label": "More", "type": "dropdown", "display": true,
                "children": [
                    // { "id": "fileFormat", "label": "File Format Download", "action": "file" },
                    { "id": "importCSV", "label": "Import Configuration", "action": "import" },
                    { "id": "exportCSV", "label": "Export CSV", "action": "export" },                    
                ]
            }],
            "editButton": [{ "id": "editButton", "class": "", "label": "Edit", "type": "normal", "display": true, "action": "edit", 'modal_id': null }],
            "saveButton": [{
                "id": "saveButton", "class": "", "label": "Save", "type": "normal", "display": false, "action": "save", 'modal_id': null
            }],
            "cancelButton": [{ "id": "cancelButton", "class": "", "label": "Cancel", "type": "normal", "display": false, "action": "cancel", 'modal_id': null }],            
            "loadingButton": [{ "id": "loadingButton", "type": "loading", "display": false, "action": "load" }]
        }

        this.dataQualityFormData = {
            "dataType": {
                "name": "dataType", "label": "Data Type", "type": "dropdown", "options": [
                    { "name": "Select Option", "value": "" },
                    { "name": "PDF", "value": "pdf" }
                ], "requiredFlag": true
            }
        }
        this.changeRawlogFormData = {
            "rawlog": {
                "name": "rawlog", "label": "Rawlog Table Name", "type": "text", "requiredFlag": true
            },
            "dimensions": {
                "name": "dimensions", "label": "Dimensions", "type": "dropdown", "multiple": true, "requiredFlag": true
            }
        }
        this.syncDatasetFormData = {
            "dateColumn": {
                "name": "dateColumn", "label": "Date Column", "type": "text", "requiredFlag": true
            }
        }

        this.change_handle = this.change_handle.bind(this);
        this.saveHandle = this.saveHandle.bind(this);
        this.change_table_format = this.change_table_format.bind(this);
        this.handleDataUpdate = this.handleDataUpdate.bind(this);
        this.text_to_json = this.text_to_json.bind(this);
        this.fetchDatasetData = this.fetchDatasetData.bind(this);
        this.submitHandle = this.submitHandle.bind(this);
        this.getJSON = this.getJSON.bind(this);
        this.clearCache = this.clearCache.bind(this);
        this.refreshFilter = this.refreshFilter.bind(this);
        this.prepareQuestion = this.prepareQuestion.bind(this);
        this.configure = this.configure.bind(this);
        this.generateNotifications = this.generateNotifications.bind(this);
        this.generateCustomSubMenu = this.generateCustomSubMenu.bind(this);
        this.uploadDataConfig = this.uploadDataConfig.bind(this);
        this.viewRawData = this.viewRawData.bind(this);
        this.fetchSampleQuestions = this.fetchSampleQuestions.bind(this);
        this.deleteView = this.deleteView.bind(this);
        this.cleanDataRefreshFilter = this.cleanDataRefreshFilter.bind(this);
        this.refreshDate = this.refreshDate.bind(this);        
        this.refreshInfo = this.refreshInfo.bind(this);
        this.fetchTableData = this.fetchTableData.bind(this);
        this.formatColumnStatus = this.formatColumnStatus.bind(this);
        this.syncData = this.syncData.bind(this);
        this.restrictMenuOption = this.restrictMenuOption.bind(this);
        this.configuration = this.configuration.bind(this);
        this.duplicateDataset = this.duplicateDataset.bind(this);
        this.exportConfig = this.exportConfig.bind(this);
        this.deleteConfig = this.deleteConfig.bind(this);
        this.importConfig = this.importConfig.bind(this);
        this.dataQuality = this.dataQuality.bind(this);
        this.changeRawlog = this.changeRawlog.bind(this);
        this.syncDropdownEvents = this.syncDropdownEvents.bind(this);
        this.refreshDropdownEvents = this.refreshDropdownEvents.bind(this);
        this.syncOnChangeHandle = this.syncOnChangeHandle.bind(this);
        this.refreshFilterChangeHandle = this.refreshFilterChangeHandle.bind(this);
    }

    componentWillMount() {
        if (this.state.tools == null || this.state.tools == null) {
            this.fetchDatasetData();
        }
        this.fetchTableData();
    }

    componentDidUpdate(prevProps, nextState) {
        if (prevProps.datasetValue !== this.props.datasetValue) {
            let that = this;
            this.fetchDatasetData();
        }
        // jQuery('[data-toggle="popover"]').popover();
        jQuery(".custom-file-input").on("change", function () {
            var fileName = jQuery(this).val().split("\\").pop();
            jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        });
    }

    fetchDatasetData(refresh = false) {
        if(refresh===false){
        this.setState({
            tools: null
        })
    }
        var that = this;
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null
        };
        if (refresh === true) {
            params['refresh'] = refresh
        }
        let postData = {
            userId: this.props.authData ? this.props.authData.userId : null
        };
        let url = '/app/tools';
        CallAPI('post', url, postData, params, 0, function (response) {
            // response = decodeResponseBody(response)
            if (response == null || response.length == 0) {
                that.setState({ tools: [] });
            } else {
                if (response?.information && refresh == true) {
                    alert(response?.information)
                } else if (refresh == false) {
                    that.setState({ tools: response.value });
                }
            }
            isDataLoading()
        }, this.props.authData)
    }


    componentDidMount() {
        // jQuery(".custom-file-input").on("change", function () {
        //     var fileName = jQuery(this).val().split("\\").pop();
        //     jQuery(this).siblings(".custom-file-label").addClass("selected").html(fileName);
        // });

    }

    change_table_format(array_data) {

        try {
            var that = this;
            let temp_array = [];

            array_data.map(function (innerData, index) {

                if (innerData.userType == 1) {

                    let inner_temp_array = [];

                    // inner_temp_array.label = innerData.last_updated_time
                    inner_temp_array.updated_time = innerData.last_updated_time;
                    inner_temp_array.dbManagementListId = innerData.dbManagementListId;
                    inner_temp_array.refId = innerData.refId;
                    inner_temp_array.isSyncPending = innerData.isSyncPending;
                    inner_temp_array.toolId = innerData.toolId;
                    inner_temp_array.status = innerData.visiblity == "1" ? "Active" : "Inactive";
                    inner_temp_array.label = innerData.name ? innerData.name : innerData[that.headerMapping['name']];
                    // inner_temp_array.name = innerData.name ? innerData.name : innerData[that.headerMapping['name']];
                    inner_temp_array.table_size = innerData.table_size;
                    inner_temp_array.total_cols = innerData.total_cols;
                    inner_temp_array.total_rows = innerData.total_rows;
                    inner_temp_array.updatedBy = innerData.updated_by;
                    inner_temp_array.synonyms = (innerData.synonyms == null || innerData.synonyms === "") ? "-" : JSON.parse(innerData.synonyms).join();
                    // inner_temp_array.synonyms = innerData.synonyms;
                    // inner_temp_array.last_updated_time = innerData.last_updated_time

                    temp_array.push(inner_temp_array);
                }

            })

            return { data: temp_array };
        } catch (e) {
            return "error";
        }
    }

    // change form submit handle
    saveHandle(e) {
        let form_array = jQuery("#add_form").serializeArray();
        let that = this;
        let viewName = form_array[0]['value'];
        let selected_table_name = form_array[1]['value'];

        if (viewName == null || viewName == undefined || viewName == "") {
            alert("Dataset name cannot be null");
        }
        else if (selected_table_name == "3") {
            alert('Table Name cannot be null!')
        }
        else {

            let form = {
                "dataset_name": viewName,
                "tableName": selected_table_name
            };
            form['dataset_name'] = form['dataset_name'].trim();
            let params = {
                siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                email: this.props.authData ? this.props.authData.username : null
            }
            if (confirm("Please Confirm to Proceed!")) {
                this.setState({
                    isProcessing: true
                })
                CallAPI('POST', '/app/make_dataset', form, params, 0, function (response) {
                    if (response.status) {
                        alert(response.information);
                        that.setState({
                            isProcessing: false
                        });
                        jQuery('#addContent').modal('toggle');
                        jQuery('#add_form').trigger("reset");

                        // window.location.reload();
                        that.fetchDatasetData();
                    }
                    else {
                        alert(response.information);
                    }
                }, this.props.authData);
            }

        }
        e.preventDefault();
    }

    // handle popout submit button
    change_handle(data) {
        let data_obj = this.state.tools;
        let final_value = data.value;
        let field = data.colDef.field == "label" ? "name" : data.colDef.field;
        let checkValidity = true
        if (field == "synonyms" || field == 'name') {
            checkValidity = checkSpecialChars(final_value) ? false : true
        }
        if (checkValidity == false) {
            alert('Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)')
            this.setState({ tools: data_obj })
        } else {
            if (this.state[data.colDef.field]) {
                Object.values(this.state[data.colDef.field]).map(function (innerData) {
                    if (innerData.name == data.value) {
                        final_value = innerData.value;
                    }
                })
            }
            if (field == "synonyms") {
                data_obj[data.node.id][field] = final_value.split(",");
            }
            else {
                data_obj[data.node.id][field] = final_value;

            }
            // metric_obj[data.rowIndex]['rockmetric_update'] = true;
            data_obj[data.node.id]['rockmetric_update'] = true;
            if (data_obj[data.node.id]['rockmetric_update_columns'] == undefined) {
                // metric_obj[data.rowIndex]['rockmetric_update_columns'] = [];
                data_obj[data.node.id]['rockmetric_update_columns'] = [];
            }
            // data_obj[data.node.id]['rockmetric_update_columns'].push(field);
            if (!data_obj[data.node.id]['rockmetric_update_columns'].includes(field)) {
                data_obj[data.node.id]['rockmetric_update_columns'].push(field);
            }
        }
    }

    //For renaming datasets
    submitHandle() {
        let that = this, checkValidity = true;
        that.state.tools && that.state.tools.map(function (innerData) {
            if (checkValidity && innerData.synonyms) {
                if (typeof innerData.synonyms === 'string') {
                    JSON.parse(innerData.synonyms).map(function (innerElement) {
                        checkValidity = checkValidity ? (checkSpecialChars(innerElement) ? false : true) : false
                    })
                } else if (typeof innerData.synonyms === 'object') {
                    innerData.synonyms.map(function (innerElement) {
                        checkValidity = checkValidity ? (checkSpecialChars(innerElement) ? false : true) : false
                    })
                }
            }
        })
        if (checkValidity === false) {
            alert('Please enter valid inputs!\n(Only alphabets, numbers, hyphen(-) & underscore(_) are allowed.)');
        } else {
            let params = {
                // siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
                // toolId: this.props.datasetValue,
                // email: this.props.authData.username
            }
            if (confirm("Please Confirm to Update!")) {
                isAdHocDataLoading();
                let tools = that.state.tools;
                // delete information as it is not required                 
                tools.forEach((currentValue, currentKey, tool) => { delete currentValue['information'] })                
                CallAPI('POST', '/app/rename_dataset', tools, params, 0, function (response) {
                    if(!response || response.status) {
                        alert("Successfully Submitted");
                    } else alert(response.information)                    
                    // window.location.reload();
                    that.fetchDatasetData();
                }, this.props.authData)
            }
        }
    }


    text_to_json(data) {
        let that = this;
        csv({
            output: "json",
            noheader: false,
            headers: Object.keys(this.headerMapping),
            // nullObject:true,
            colParser: {
                "isDerived": function (item, head, resultRow, row, colIdx) {
                    let metricType = that.getJSON(Object.values(that.state[head]));
                    return metricType[item] ? metricType[item] : null;
                },
                "isDisplay": function (item, head, resultRow, row, colIdx) {
                    let displayType = that.getJSON(Object.values(that.state[head]));
                    return displayType[item] ? displayType[item] : null;
                }
            }
        }).fromString(data)
            .then(function (result) {
                let metric = that.state.metric;

                metric.metric = [...result, ...metric.metric];
                that.setState({
                    metric: metric
                });
                // that.TableParent.handleButton(null, 1);
            })
    }


    handleDataUpdate(data) {
        let metric = this.state.metric;
        metric.metric = data;
        this.setState({
            metric: metric
        })
    }


    getJSON(data) {
        let result = {};
        data.map((element, i) => {
            result[element.name] = element.value;
        });
        return result;
    }

    clearCache() {
        let indexedDB = this._db
        let params = {
            siteId: this.props.authData.siteId,
            toolId: gridOptions.api.getSelectedNodes()[0]['data']['toolId'],
            auth: "system"
        }
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('GET', '/app/system/clearCache', null, params, 0, function (response) {
                if (response.status === true) {
                    alert(response.information)
                    IDBStoreNames.forEach(el => {
                        indexedDB.deleteAll(el)
                    })                    
                    isDataLoading(false)
                } else alert(response.error_message)
            }, this.props.authData)
        }
    }

    prepareQuestion(params) {
    }

    viewRawData() {

        let selectedTable = (gridOptions.api.getSelectedNodes())[0]['data']['raw_table'];
        let siteId = localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null;
        let toolId = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
        if (selectedTable == null || selectedTable == undefined) {
            selectedTable = `customer_${siteId}.rawlog_${toolId}_${siteId}`;
        }
        let pathname = '/admin/raw_data';
        let search = `?raw_data=${selectedTable}&tableFlag=1&toolId=${toolId}`;
        let url = `${pathname}${search}`;

        var win = window.open(url, '_blank');
        // this.props.history.push({
        //     pathname: '/raw_data',
        //     search: `?raw_data=${selectedTable}`,
        //     state: { raw_data: selectedTable }
        // })
    }

    fetchSampleQuestions(e) {
        let that = this;
        let selectedDataset = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset,
            refresh: e == 'download' || e == 'prepareDownload' ? true : undefined,
            download: e == 'prepareDownload' ? true : undefined,
        }
        let url = e == 'prepare' || e == 'prepareDownload' ? "/app/prepareSampleQuestion" : "/app/downloadSampleQuestion"
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('POST', url, params, null, 0, function (response) {
                if (response == true) {
                    isDataLoading(false)
                    alert("Questions prepared successfully!")
                } else if (response?.type == 'csv') {
                    isDataLoading(false)
                    let binaryData = [];
                    alert("Questions downloaded succesfully!")
                    let decodedData = atob(response.csvData)
                    binaryData.push(decodedData);
                    const link = document.createElement('a');
                    const fileURL = window.URL.createObjectURL(new Blob(binaryData, { type: "text/csv" }))
                    link.href = fileURL;
                    link.download = response.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(fileURL);
                }else{
                    alert("Something went wrong!")
                }
            }, this.props.authData)
        }
    }

    configure(name = null) {
        if (name == "insight") name = "configInsight";
        let selectedDataset = null;
        let path = null;
        if (name !== null) {
            selectedDataset = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];

            let menuOptions = this.generateCustomSubMenu(this.props.menuOptions)

            path = (menuOptions[name] !== null && menuOptions[name] !== undefined) ? menuOptions[name]['link'] : null;


            let pathObject = { pathname: path };
            this.props.setToolId(selectedDataset);
            this.props.history.push(path)
        }
    }

    // generates the configuration options to perform on the Dataset from AdminParent Menu array
    generateCustomSubMenu(options = null) {
        let that = this;
        let object = (options !== null) ? options : this.props.menuOptions;
        let subMenu = {};
        for (var key in object) {
            if (object.hasOwnProperty(key) && (object[key]['showMenu'] !== false)) {
                if (object[key]["children"] !== null && object[key]["children"] !== undefined) {
                    let menu = that.generateCustomSubMenu(object[key]["children"]);
                    subMenu = { ...subMenu, ...menu };
                }
                else {
                    object[key]['action'] = null;
                    subMenu[key] = object[key];
                }
            }
        }
        return subMenu;
    }

    uploadDataConfig(name = null) {

        if (name == "append") {
            this.setState({
                upload: { "title": "Append Data", "button_name": "Append", "type": 1 }
            });
        }
        else if (name == "overwrite") {
            this.setState({
                upload: { "title": "Overwrite Data", "button_name": "Overwrite", "type": 2 }
            });
        }
        jQuery("#addContent").modal('show');
    }

    deleteView() {

        let that = this;
        let selectedDataset = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset
        }
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('POST', '/app/delete_dataset', null, params, 0, function (response) {
                if (response.status) {
                    alert(response.information);
                    that.fetchDatasetData();
                }
            }, this.props.authData)
        }
    }

    refreshFilter() {
        selectedDataset = gridOptions.api.getSelectedNodes()[0]['data']['toolId'];
        jQuery('#refreshFilterModal').modal('toggle');
    }

    cleanDataRefreshFilter() {

        let that = this;
        let selectedDataset = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset,
            type: 'filter',
            refresh: 'refresh',
            auth: "system"
        }
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('GET', '/app/system/bulkUpdate', null, params, 0, function (response) {
                alert("Filters Refreshed Successfully!")
                isDataLoading(false)
            }, this.props.authData)
        }
    }

    refreshDate() {
        let that = this;
        let selectedDataset = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset
        }
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('GET', '/app/refreshDate', null, params, 0, function (response) {
                alert("Dates Refreshed Successfully!")
                isDataLoading(false)
            }, this.props.authData)
        }
    }

    refreshInfo() {
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            this.fetchDatasetData(true);
            
        }
    }

    fetchTableData(refresh = false) {
        let that = this;

        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            // toolId: this.props.datasetValue
        }
        if (refresh == true) {
            params['refresh'] = true;
        }
        CallAPI('get', '/app/get_pulled_tables', null, params, 0, function (response) {
            let refinedRawTable = [];
            if (response.status) {
                refinedRawTable = response.information.map((element, i) => {
                    let rawData = {};
                    rawData['value'] = element['targetTableName'];
                    rawData['name'] = element['virtualTableName'];
                    return rawData;
                });
            }
            that.setState({ tables: refinedRawTable });
            that.props.setTableData(response.information);
        }, this.props.authData)
    }

    formatColumnStatus(params) {
        let htmlString = `<span>${params.value}</span>`;
        let index = params.node.id;
        let icon = '';
        let status = this.state.tools[index]['isSyncPending'];

        let error_message = '';
        if ((status !== null || status == "0") && status !== undefined) {
            let id = `${params.value}_${index}`;
            if (status == "1") {
                // icon = '<i class="fas fa-check-circle mg-t-2 float-right mg-t-5" style="color:#04cc82"></i>';
                error_message = "Dataset is not synced";
                icon = '<i id="' + id + '" class="fas fa-sync float-right mg-t-5" data-container="body" data-toggle="popover" data-placement="bottom"  data-content="' + error_message + '" style="color:#ff726f"></i>';
            }
            else if (status == "-1") {
                // icon = '<i id="' + id +'" class="fas fa-exclamation-circle float-right mg-t-5" data-container="body" data-toggle="tooltip" data-placement="bottom" title="'+error_message+'" style="color:#ff726f"></i>';
                error_message = "Dataset Sync in process";
                icon = '<i id="' + id + '" class="fas fa-sync fa-spin float-right mg-t-5" data-container="body" data-toggle="popover" data-placement="bottom"  data-content="' + error_message + '" style="color:#04cc82"></i>';
                // icon = `<i class="fas fa-exclamation-circle mg-t-2 float-right" data-container="body" data-toggle="popover" data-placement="bottom" data-content="Vivamus sagittis lacus vel augue laoreet rutrum faucibus." style="color:#ff726f"></i>`;
            }

            htmlString = `<span>${params.value}${icon}</span>`;
        }

        return htmlString;
    }

    // syncData() {
    //     const that = this;

    //     const toolId = (gridOptions.api.getSelectedNodes())[0]['data']['toolId'];
    //     const db_management_id = gridOptions.api.getSelectedNodes()[0]['data']['dbManagementListId'];
    //     const refId = gridOptions.api.getSelectedNodes()[0]['data']['refId'];

    //     const params = {
    //         "siteId": localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
    //         "email": this.props.authData.username,
    //         "toolId": toolId,
    //         "dbManagementListId": db_management_id,
    //         "refId": refId,
    //         "userId": this.props.authData.userId
    //     };

    //     const data = {
    //         "db_management_id": db_management_id
    //     };


    //     let url = '/app/sync_data';
    //     CallAPI('get', url, data, params, 0, function (response) {
    //         if (response.status) {
    //             alert(response.information);
    //         }
    //         else {
    //             alert(response.information);
    //         }
    //         that.fetchDatasetData();

    //     }, this.props.authData)
    // }

    syncData() {
        let that = this
        let selectedToolId = gridOptions.api.getSelectedNodes()[0]['data']['toolId']
        that.props.setToolId(selectedToolId)
        let tempFormVar = that.state.syncDataFormStates
        that.state.tools.map(function (innerData) {
            if (innerData.toolId === selectedToolId && innerData.sync_frequency !== null) {
                tempFormVar['status']['text_value'] = JSON.parse(innerData.sync_frequency).status
                tempFormVar['frequency']['text_value'] = JSON.parse(innerData.sync_frequency).frequency ? JSON.parse(innerData.sync_frequency).frequency : ''
                tempFormVar['timeOfDay']['text_value'] = JSON.parse(innerData.sync_frequency).timeOfDay ? JSON.parse(innerData.sync_frequency).timeOfDay : ''
                tempFormVar['dayOfWeek']['text_value'] = JSON.parse(innerData.sync_frequency).dayOfWeek ? JSON.parse(innerData.sync_frequency).dayOfWeek : ''
                tempFormVar['dayOfMonth']['text_value'] = JSON.parse(innerData.sync_frequency).dayOfMonth ? JSON.parse(innerData.sync_frequency).dayOfMonth : ''
            }
        })
        that.setState({ syncDataFormStates: tempFormVar })
        jQuery('#syncDataModal').modal('toggle');
    }

    syncOnChangeHandle(e) {
        this.state.syncDataFormStates[e.target.name].text_value = e.target.value
    }
    refreshFilterChangeHandle(e) {
        this.state.refreshFilterState[e.target.name].text_value = e.target.value

    }

    refreshDropdownEvents(e){
        var tempFormData = this.state.refreshFilterState
        tempFormData[e.target.name].text_value = e.target.value
        if(e.target.value!=''){
            tempFormData.refreshFilter['extraInfo'] = true
        }
        if (e.target.value === 'elasticsearch') {
            tempFormData.refreshFilter['extraValue'] = 'Rebuild the filter with the existing data'
        }else if(e.target.value==='none'){
            tempFormData.refreshFilter['extraValue'] = 'Rebuild the entire filter with the new data'
        }else if(e.target.value==='true'){
            tempFormData.refreshFilter['extraValue'] = 'Clean data for special characters and rebuild the filter'
        }else{
            tempFormData.refreshFilter['extraInfo'] = false

        }
        this.setState({ refreshFilterState: tempFormData })
    }

    syncDropdownEvents(e) {
        var tempFormData = this.state.syncDataFormStates
        tempFormData[e.target.name].text_value = e.target.value
        if (e.target.name === 'frequency') {
            if (e.target.value === 'daily' || e.target.value === '') {
                tempFormData['dayOfWeek']['type'] = 'hide'
                tempFormData['dayOfMonth']['type'] = 'hide'
            } else if (e.target.value === 'weekly') {
                tempFormData['dayOfWeek']['type'] = 'dropdown'
                tempFormData['dayOfMonth']['type'] = 'hide'
            } else if (e.target.value === 'monthly') {
                tempFormData['dayOfWeek']['type'] = 'hide'
                tempFormData['dayOfMonth']['type'] = 'number'
            }
        } else if (e.target.name === 'status') {
            if (e.target.value === 0) {
                tempFormData['frequency']['disabled'] = true
                tempFormData['timeOfDay']['disabled'] = true
                tempFormData['dayOfWeek']['disabled'] = true
                tempFormData['dayOfMonth']['disabled'] = true
            } else if (e.target.value === 1) {
                tempFormData['frequency']['disabled'] = false
                tempFormData['timeOfDay']['disabled'] = false
                tempFormData['dayOfWeek']['disabled'] = false
                tempFormData['dayOfMonth']['disabled'] = false
            }
        }
        this.setState({ syncDataFormStates: tempFormData })
    }

    restrictMenuOption(params, actionArray) {
        let disabledFlag = false
        let syncFlag = false
        const menuOption = {
            main: "actions",
            subMenu: "syncData"
        }
        this.state.tools.map(function (innerData) {
            if (innerData.toolId === params.data.toolId && innerData.sync_frequency !== null) {
                syncFlag = true
            }
        })
        if (syncFlag === false) {
            if (actionArray.name == menuOption.subMenu) {
                disabledFlag = true
            }
        }
        return disabledFlag;
    }

    duplicateDataset() {
        let URL = "/app/copyConfigs";
        this.configuration("export", URL, "POST", { newDatasetName: `Duplicate ${(gridOptions.api.getSelectedNodes())[0]['data']['label']}`, copyData: "1" }, null);
    }

    exportConfig() {
        let URL = "/app/system/generateJSON";
        this.configuration("exportConfig", URL, "POST", null, "blob");
    }

    deleteConfig() {
        let URL = "/app/delete_configs";
        this.configuration("export", URL, "POST", {deleteType: 1}, null);
    }

    importConfig(){
        if(document.getElementById("name_form_data").value && jQuery("#zipfile")[0].files[0]){
            var formData = new FormData();
            formData.append('newDatasetName', document.getElementById("name_form_data").value);
            formData.append('copyData', 1);
            formData.append('zipFile', jQuery("#zipfile")[0].files[0]);
            let URL = "/app/system/importJSON";
            this.configuration("import", URL, "POST", formData, null);
        }else {
            alert("File fill the correct values!");
        }
    }

    configuration(type, URL, method, postData = null, responseType = null) {
        let selectedDataset = type!="import" ? (gridOptions.api.getSelectedNodes())[0]['data']['toolId'] : null;
        var that = this;

        let params = {
            siteId: this.props.authData.siteId,
            toolId: selectedDataset
        }

        if(type=="import"){
            this.setState({
                isProcessing:true
            })
            params.auth = "system";
            postData.append('user', this.props.authData.userId)
        } else if (type == "exportConfig") {
            params.auth = "system";
            postData = { 'user': this.props.authData.userId }
        }
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI(method, URL, postData, params, 0, function (response) {
                if (responseType == "blob") {
                    //Build a URL from the file
                    const fileURL = window.URL.createObjectURL(response);
                    //Open the URL on new Window
                    window.open(fileURL);
                } else {
                    if (type == "import") {
                        jQuery('#addContent').modal('hide');
                        jQuery('#add_form').trigger("reset");
                        that.setState({
                            isProcessing: false
                        })
                    }
                    that.fetchDatasetData();
                }
                isDataLoading(false)
            }, this.props.authData, responseType)
        }
    }

    dataQuality() {
        jQuery('#dataQualityModal').modal('toggle');
    }

    changeRawlog() {
        selectedDataset = gridOptions.api.getSelectedNodes()[0]['data']['toolId'];
        let dOptions = []
        this.props.allProperty && Object.values(this.props.allProperty).map(function (innerData) {
            dOptions.push({ "name": innerData.label, "value": innerData.value })
        })
        this.setState({ dimensionOptions: dOptions })
        jQuery("#changeRawlogModal").modal('toggle')
    }
    generateNotifications() {
        let that = this
        let selectedDataset = gridOptions.api.getSelectedNodes()[0]['data']['toolId'];
        let postData = { 'userId': this.props.authData ? this.props.authData.userId : null }
        let params = {
            siteId: localStorage.Dataset ? JSON.parse(localStorage.Dataset).siteId : null,
            toolId: selectedDataset
        };
        let url = '/app/generateNotification';
        if (confirm("Please Confirm to Proceed!")) {
            isDataLoading(true)
            CallAPI('POST', url, postData, params, 0, function (response) {
                that.fetchDatasetData()
            }, this.props.authData)
        }
    }
    
    syncDataset() {
        jQuery('#syncDatasetModal').modal('toggle')
    }

    render() {

        let that = this;
        var mainData = <LoadingComponent />;

        // listens for the event when modal is closed and resets the title and button for #addContent Modal
        jQuery('#addContent').on('hidden.bs.modal', function (e) {
            if (that.state.upload.type !== 0) {
                that.setState({
                    upload: { "title": "Upload Data", "button_name": "Upload", "type": 0 }
                })
            }
        });
        if (this.state.tools) {

            let final_data = this.change_table_format(this.state.tools);

            if (final_data !== "error") {
                var columns_array = [
                    // { label: "Name", value: "name", type: "html", editable: true, cellStyle: { 'text-align': 'left' } },
                    { label: "Status", value: "status", type: "html", editable: false, dataType: 'string', hide: false },
                    { label: "Total Rows", value: "total_rows", type: "number", editable: false, dataType: 'number' },
                    { label: "Total Columns", value: "total_cols", type: "number", editable: false, dataType: 'number' },
                    { label: "Email Subject", value: "synonyms", type: "string", editable: true, dataType: 'string' },
                    { label: "Last Updated Time", value: "updated_time", type: "datetime", hide: true, dataType: 'string' },
                    { label: "Updated By", value: "updatedBy", type: "string", hide: true, dataType: 'string' },
                    // { label: " ", value: " ", type: "html",button:true}
                ];


                var firstColumn = "Name";
                var Form_Data = '';

                if (this.state.tables !== null) {
                    var formData = {
                        "name": { "name": "name", "label": "Dataset Name", "type": "text", required: true },
                        // "importType": {
                        //     "name": "importType", "label": "Import Type", "type": "dropdown", "options": [
                        //         { "name": "Import Zip", "value": "zip" }, { "name": "Select Table", "value": "table" }
                        //     ]
                        // },
                        "zipFileName": {
                            "name": "zipFileName", "label": "Configuration", "type": "file","id":"zipfile", required: true
                        },
                        // "tableName": {
                        //     "name": "tableName", "label": "Select Table", "type": "dropdown", "options": [
                        //         { "name": "Select Option", "value": "3" }, ...this.state.tables
                        //     ], "disabled": true
                        // }
                    }

                    Form_Data = <Form label_array={formData} call_back={this.call_back_form} />;

                }
                var Bulk_Form_Data = <Form label_array={this.bulkFormData} call_back={this.call_back_form} />;
                var import_Form_Data = <Formv2 label_array={this.importFormData} />;

                var dataQualityFormArray = this.dataQualityFormData ? JSON.parse(JSON.stringify(this.dataQualityFormData)) : null
                dataQualityFormArray['dataType']['text_value'] = "pdf"
                var dataQuality_Form_Data = <Formv2 label_array={dataQualityFormArray} />

                var changeRawlogFormArray = this.changeRawlogFormData ? JSON.parse(JSON.stringify(this.changeRawlogFormData)) : null
                changeRawlogFormArray['dimensions']['options'] = this.state.dimensionOptions
                var changeRawlog_Form_Data = <Formv2 label_array={changeRawlogFormArray} />
                
                var refreshFilter_Form_Data = <Formv2 label_array={this.state.refreshFilterState} handle_form_drop_down={this.refreshDropdownEvents}  handleForm={this.refreshFilterChangeHandle}/>

                var syncData_Form_Data = <Formv2 label_array={this.state.syncDataFormStates} handle_form_drop_down={this.syncDropdownEvents} handleForm={this.syncOnChangeHandle} />

                var syncDataset_Form_Data = <Formv2 label_array={this.syncDatasetFormData} />

                var modals = {
                    "addModal": {
                        "form_name": "add_form", "title": this.state.upload['title'], "body": Form_Data, "button_name": this.state.upload['button_name'], "action": "add", "display": true, "isLoading": this.state.isProcessing, "formKey": `create_Dataset_${Math.floor(Math.random()*10)}`
                    },
                    "bulkModal": {
                        "form_name": "bulk_form", "title": "Edit Metric", "body": Bulk_Form_Data, "button_name": "Update", "action": "bulk", "display": false
                    },
                    "importModal": {
                        "form_name": "import_form", "title": "Import Configuartions", "body": import_Form_Data, "button_name": "Import", "buttonType": "submit", "action": "import", "display": true
                    },
                    "dataQualityModal": {
                        "id": "dataQualityModal", "form_id": "dataQuality_form", "form_name": "dataQuality", "title": "Data Quality", "body": dataQuality_Form_Data, "button_name": "Generate", "buttonType": "submit", "action": "dataQuality", "display": true
                    },
                    "changeRawlogModal": {
                        "id": "changeRawlogModal", "form_id": "rawlog_form", "form_name": "changeRawlog", "title": "Change Rawlog Connection", "body": changeRawlog_Form_Data, "button_name": "Save", "buttonType": "submit", "action": "changeRawlog", "display": true, "formKey": `changeRawlog_${Math.floor(Math.random()*10)}`
                    },
                    "refreshFilterModal": {
                        "id": "refreshFilterModal", "form_id": "refreshFilter_form", "form_name": "refreshFilter", "title": "Refresh Filter", "body": refreshFilter_Form_Data, "button_name": "Refresh", "buttonType": "submit", "action": "refreshFilter", "display": true,"formKey": `refreshFilter_${Math.floor(Math.random()*100)}`
                    },
                    "syncDataModal": {
                        "id": "syncDataModal", "form_id": "syncData_form", "form_name": "syncData", "title": "Sync Dataset", "body": syncData_Form_Data, "button_name": "Save", "buttonType": "submit", "action": "syncData", "display": true, "formKey": `syncData_${Math.floor(Math.random()*10)}`
                    },
                    "syncDatasetModal": {
                        "id": "syncDatasetModal", "form_id": "syncDataset_form", "form_name": "syncDataset", "title": "Sync Dataset", "body": syncDataset_Form_Data, "button_name": "Save", "buttonType": "submit", "action": "syncDataset", "display": true, "formKey": `syncDataset_${Math.floor(Math.random()*10)}`
                    }
                }

                // For extra Context Menu Options, seperate instantiations to be defined and called,
                // for the Dataset Page ,the folowing config is passed
                var customMenu = {
                    "configure": {
                        "name": "configure", "label": "Build Data Model", "action": this.configure,
                        "items": this.generateCustomSubMenu()
                    },
                    "actions": {
                        "name": "actions", "label": "Actions", "action": this.configure,
                        "items": {
                            "dataQuality": { "name": "dataQuality", "label": "Data Quality", "action": this.dataQuality },
                            "changeRawlog": { "name": "changeRawlog", "label": "Change Rawlog Connection", "action": this.changeRawlog },
                            "viewData": { "name": "viewData", "label": "View Raw Data", "action": this.viewRawData },
                            "sampleQuestions": {
                                "name": "sampleQuestions", "label": "Sample Questions", "subItems": [
                                   { "name": "prepare", "label": "Prepare", "action": this.fetchSampleQuestions},
                                   { "name": "download", "label": "Download", "action": this.fetchSampleQuestions},
                                    // {"name": "prepareDownload", "label": "Prepare and Download", "action": this.fetchSampleQuestions},
                                ]
                            },

                            "syncData": { "name": "syncData", "label": "Sync Data", "action": this.syncData },
                            "refreshDate": { "name": "refreshDate", "label": "Refresh Date", "action": this.refreshDate },
                            "clearCache": { "name": "clearCache", "label": "Clear Cache", "action": this.clearCache },
                            "syncDataset": { "name": "syncDataset", "label": "Sync Dataset", "action": this.syncDataset },
                            "refreshFilter": { "name": "refreshFilter", "label": "Refresh Filter", "action": this.refreshFilter },
                            // "cleanDataRefreshFilter": { "name": "cleanDataRefreshFilter", "label": "Clean Data & Refresh Filter", "action": this.cleanDataRefreshFilter },                            
                            "downloadConfig": { "name": "downloadConfig", "label": "Export Configuration", "action": this.exportConfig },
                            "duplicateDataset": { "name": "duplicateDataset", "label": "Duplicate Dataset", "action": this.duplicateDataset },
                            "deleteData": { "name": "deleteData", "label": "Delete Dataset", "action": this.deleteView },
                            "deleteConfig": { "name": "deleteConfig", "label": "Force Delete Dataset", "action": this.deleteConfig },
                            "generateNotifications": { "name": "generateNotifications", "label": "Generate Notifications", "action": this.generateNotifications }
                            //  "question": {
                            //     "name": "question", "label": "Prepare Questions", "action": this.prepareQuestion, "items":null
                            // },
                        }
                    },
                    "refreshInfo": {
                        "name": "refreshInfo", "label": "Refresh Dataset Info", "action": this.refreshInfo,
                    }
                }

                mainData = <TableParent
                    data={final_data}
                    parentConfig={this.state}
                    columns_array={columns_array}
                    firstColumn={firstColumn}
                    editData={this.state.tools}
                    modalConfig={modals}
                    onCellChange={this.change_handle}
                    filename="View List"
                    // actionArray={this.props.menuData}
                    menuAction={this.handleMenuAction}
                    handleDataUpdate={this.handleDataUpdate}
                    // saveHandle={this.saveHandle}
                    saveHandle={this.importConfig}
                    buttonConfig={this.buttons}
                    submitHandle={this.submitHandle}
                    importJSON={this.text_to_json}
                    customMenu={customMenu}
                    rowSelection="single"
                    page="dataset"
                    firstCellEdit={true}
                    firstCellRender={this.formatColumnStatus}
                    restrictOption={this.restrictMenuOption}
                    fetchDatasetData={this.fetchDatasetData}
                />
            }
            else {
                mainData = <ErrorComponent />;
            }

        }
        // else {
        //     mainData = <ErrorComponent />;
        // }

        return (
            <div className="">
                {mainData}
            </div>
        );
    }
}

function mapStateToProps(state) {
    return { 
        toolId: state.admin.toolId, 
        authData: state.dataSet.authData,
        tableData: state.admin.tableData,
        allProperty: state.dataSet?.alfred?.property
    };
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        setToolId, setTableData
    }, dispatch)
}

// export default DatasetComponent;
export default connect(mapStateToProps, mapDispatchToProps)(DatasetComponent);